import { render, staticRenderFns } from "./TheDashboardHeader.vue?vue&type=template&id=525c6d30"
import script from "./TheDashboardHeader.vue?vue&type=script&lang=js"
export * from "./TheDashboardHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports